import { useState } from 'react';

import { useSubscription } from '@apollo/client/react';

import { graphql } from '@/gql';

const STREAM_ASSISTANT_RESPONSE_SUBSCRIPTION = graphql(`
  subscription StreamAssistantResponse($conversationItem: ID!) {
    streamOrtooGptResponse(conversationItem: $conversationItem) {
      text
      complete
      error
    }
  }
`);

export const useStreamAssistantResponse = (
  conversationItemId: string | null | undefined,
  skip: boolean,
) => {
  const [response, setResponse] = useState<string | null>(null);

  const [serverLoading, setServerLoading] = useState(false);
  const [serverError, setServerError] = useState<string | null>(null);
  const [completed, setCompleted] = useState(false);

  const { loading: clientLoading, error: clientError } = useSubscription(
    STREAM_ASSISTANT_RESPONSE_SUBSCRIPTION,
    {
      variables: { conversationItem: conversationItemId ?? '' },
      skip: !conversationItemId || completed || skip,
      onData({ data: { data } }) {
        const {
          text,
          complete,
          error: serverError,
        } = data?.streamOrtooGptResponse ?? {};

        if (serverError) {
          setServerError(serverError);
          setServerLoading(false);
          setCompleted(true);
          return;
        }

        if (complete) {
          setServerLoading(false);
          setCompleted(true);
          return;
        }

        const next = text ?? '';
        setResponse((prev) => (prev ? prev + next : next));
      },
      onError(error) {
        if (error.message?.toLowerCase().includes('socket closed')) {
          setCompleted(true);
          setServerLoading(false);
        } else {
          console.error('Streaming error:', error);
        }
      },
    },
  );

  const loading = clientLoading || serverLoading;

  const errorMessage = serverError
    ? serverError
    : clientError
      ? clientError.message
      : null;

  return {
    loading,
    clientLoading,
    serverLoading,
    clientError,
    serverError,
    errorMessage,
    response,
    completed,
  } as const;
};
